import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-local-customer-filter',
  templateUrl: './local-customer-filter.component.html',
  styleUrls: ['./local-customer-filter.component.scss']
})
export class LocalCustomerFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  localCustomerListFilter: any[];

  @Input() localCustomerData: any;
  @Input() localCustomerSelected: LocalCustomerModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('localCustomerData' in changes) {
      this.localCustomerListFilter = this.localCustomerData ? this.localCustomerData : [];
      this.optionSelected = null;
    }
    if (this.localCustomerSelected) {
      this.optionSelected = this.localCustomerSelected;
    }
  }

  ngOnDestroy(): void {
  }

}
